import {
  getNameDescriptionTableColumn,
  getAccountTableColumn,
  getStatusTableColumn,
} from '@/utils/common/tableColumn'
import {
  getCollectLogsColumn,
  getCacheTtlColumn,
  getRequestRateLimitColumn,
  getAuthenticationColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getStatusTableColumn({ vm: this, statusModule: 'aiGateway' }),
      getCollectLogsColumn(),
      getCacheTtlColumn(),
      getRequestRateLimitColumn(),
      getAuthenticationColumn(),
      getAccountTableColumn(),
    ]
  },
}
